import { Component, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
@UntilDestroy()
@Component({
    selector: 'company-addresses-array',
    templateUrl: './company-addresses-array.component.html',
    styleUrls: ['./company-addresses-array.component.scss'],
    standalone: false
})
export class CompanyAddressesArrayComponent implements OnInit {
  copmanyAddressForm: UntypedFormArray;

  @Input() derrors: any = undefined;
  countries: any[];
  departments: any[];
  reference$;
  toValue: PlaceSearchResult = { address: '' };
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;
  sessionConsultant: boolean;

  constructor(
    private controlContainer: ControlContainer,

    private referenceDao: ReferenceDao,
    private subscriptionFacade: SubscriptionFacadeService,
    private attributionDao: AttributionDao,
  ) {}

  ngOnInit() {
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.copmanyAddressForm = this.controlContainer.control as UntypedFormArray;
    combineLatest([this.referenceDao.getCountries()])
      .pipe(untilDestroyed(this))
      .subscribe(([countries]: any) => {
        this.countries = countries;
      });
  }

  addFields() {
    this.copmanyAddressForm.markAsDirty();
    this.copmanyAddressForm.markAllAsTouched();

    if (this.copmanyAddressForm.valid) {
      this.copmanyAddressForm.push(
        new UntypedFormGroup({
          street: new UntypedFormControl(''),
          zipCode: new UntypedFormControl(''),
          city: new UntypedFormControl(''),
          country: new UntypedFormControl(''),
        }),
      );

      this.copmanyAddressForm.markAsUntouched();
      this.copmanyAddressForm.markAsDirty();
    } else {
      this.copmanyAddressForm.markAllAsTouched();
    }
  }

  deleteFields(index) {
    this.copmanyAddressForm.removeAt(index);

    this.copmanyAddressForm.markAsDirty();
    this.copmanyAddressForm.markAllAsTouched();
  }

  ngOnChanges() {
    if (this.copmanyAddressForm)
      this.copmanyAddressForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
